// @flow

import NotificationActions from "../actions/NotificationActions";
import WebApi from '../WebApi';
import _ from "underscore";

import t from '../trans';
import SoftwareUpdateActions from "../actions/SoftwareUpdateActions";

let SoftwareUpdateSource = {
	fetchSoftwareInfo(user, passwd) {
		return {
			remote(state, user, passwd) {
				return WebApi.getSoftwareInfo(user, passwd);
			},

			local() {
				return null;
			},

			success: SoftwareUpdateActions.fetchSoftwareInfoDone,
			error: SoftwareUpdateActions.fetchSoftwareInfoFailed
		};
	},
	update(file, user, passwd) {
		return {
			remote(state, file, user, passwd) {
				try {
					return WebApi.postSoftwareUpdate(file, user, passwd);
				} catch (e) {
					if (!_.isString(e)) {
						console.log(e.toString());
						NotificationActions.error.defer(t("Internal error"));
					}
					else NotificationActions.error.defer(e);

					return new Promise((resolve, reject) => {reject(e);});
				}
			},
			
			local() {
				return null;
			},
			
			success: SoftwareUpdateActions.updateDone,
			error: SoftwareUpdateActions.updateFailed
		};
	},

	restore(user, passwd) {
		return {
			remote(state, user, passwd) {
				try {
                    return WebApi.postSoftwareRestore(user, passwd);
				} catch (e) {
                    if (!_.isString(e)) {
                        console.log(e.toString());
                        NotificationActions.error.defer(t("Internal error"));
                    }
                    else NotificationActions.error.defer(e);

                    return new Promise((resolve, reject) => {reject(e);});
				}
			},
			
			local() {
				return null;
			},
			
			success: SoftwareUpdateActions.restoreDone,
			error: SoftwareUpdateActions.restoreFailed
		};
	}
};

export default SoftwareUpdateSource;
